<template>
<div class="chapter">
<div class="inner_page">
<p class="indent"><a id="page_viii"></a> </p>
<p class="image1"><a id="page_ix"></a><img alt="Images" src="images/f0009-01.jpg"/></p>
<div class="box">
<p class="center1"><span class="red"><strong>Wise advice from a character named Arnbi, whom you’ll meet soon enough:</strong></span></p>
<p class="center2"><span class="blue"><em><strong>Too bad, but “simple” is a square peg that seldom fits into the round hole that is our modern world.</strong></em></span></p>
</div>
<p class="indent"><a id="page_x"></a> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter.vue?b234c472